import classNames from 'classnames';
import type { ComponentType } from 'react';
import React from 'react';
import { ImSpinner } from 'react-icons/im';
import './LoadingIndicator.scss';

type Props = {
  as?: string | ComponentType<{ className?: string }>;
  className?: string;
};

const LoadingIndicator = (props: Props) => {
  const Component = props.as || 'div';
  return (
    <Component className={classNames('loading-indicator', props.className)}>
      <ImSpinner className="react-icons loading-indicator-icon-spin" />
    </Component>
  );
};

export default LoadingIndicator;
